import { Component, Input, OnInit, inject } from "@angular/core";
import { Router } from "@angular/router";
import { NbIconModule } from "@nebular/theme";

@Component({
  standalone: true,
  selector: "ngx-video-actions",
  templateUrl: "./video-actions.component.html",
  imports: [NbIconModule],
})
export class VideoActionsComponent implements OnInit {
  private router = inject(Router);

  @Input() actions: any;

  ngOnInit() {}

  actionClick(action: any, i: number): boolean {
    if (action.type == "rating") {
      this.actions[i].icon =
        this.actions[i].icon == "star" ? "star-outline" : "star";
    } else if (action.type == "link") {
      this.router.navigate([action.link]);
    } else {
      window.open(action.link, "_blank");
    }
    return true;
  }
}
